import React from "react";
import "./Activitse.css";
import LoadingSkeleton from "./LoadingSkeleton";
import SingleActivity from "./SingleActivity";

const ActivitiesContent3 = (props) => {
  return (
    <>
      <div className="row mt-3">
        {props.loader ? (
          props.event.map((event) => {
            return (
              <>
                <SingleActivity
                  event={event.learning_session}
                  event_type="learning_session"
                />
              </>
            );
          })
        ) : (
          <LoadingSkeleton />
        )}
      </div>
    </>
  );
};

export default ActivitiesContent3;
